import { ChannelKind } from '../interfaces/channels'

/** A person talking to you — a 1:1 or a group chat — rather than a group's thread. */
export const isDmKind = (kind: ChannelKind): boolean =>
  kind === ChannelKind.Dm || kind === ChannelKind.GroupDm

/** A named group — the container threads live in, not a thread or a DM. */
export const isGroupChannel = (channel: {
  kind: ChannelKind
  parentChannelId: string | null
}): boolean => channel.kind === ChannelKind.Channel && !channel.parentChannelId
